import * as React from 'react';
import { DirectoryStoreState } from '../../types';
import { sortOrderOptions } from '../../constants';
import { useCallback } from 'react';
import { useDispatch, useMappedState } from 'redux-react-hook';
import { setSortOrder } from '../../actions';

export interface SortOrderPanelProps {}

export const SortOrderPanel: React.FC<SortOrderPanelProps> = () => {
  const { sortOrder } = useMappedState(
    useCallback(
      (state: DirectoryStoreState) => ({
        sortOrder: state.stores.sortOrder,
      }),
      []
    )
  );
  const dispatch = useDispatch();
  const onChange = (SortOrder: string) => dispatch(setSortOrder(SortOrder));

  return (
    <div className="sortOrder">
      <select value={sortOrder} onChange={e => onChange(e.target.value)}>
        {sortOrderOptions.map((option, i) => (
          <option value={option} key={i}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
};
